import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ButtonModule } from '../button/button.module';
import { UploadFileModule } from '../upload-file/upload-file.module';
import { UploadFileDialogComponent } from './upload-file-dialog.component';

@NgModule({
    imports: [CommonModule, TranslatePipe, TranslateDirective, DragDropModule, ButtonModule, UploadFileModule],
    declarations: [UploadFileDialogComponent],
    exports: [UploadFileDialogComponent]
})
export class UploadFileDialogModule {}
